export default __webpack_public_path__ + "static/media/ERRIN_SingleMan_comic.efed5ca1.pdf";